import { COLORS } from '@/constants';
import { Typography } from '@mui/material';
import styled from 'styled-components';

export const Wrapper = styled.div`
  background: ${COLORS['neutral/50']};
  border: 1px solid ${COLORS['neutral/300']};
  border-radius: 6px;
  padding: 24px;

  @media (max-width: 600px) {
    padding: 16px;
  }
`;

export const LineWrapper = styled('div')`
  display: flex;
  justify-content: space-between;
  gap: 15px;
  margin-bottom: 14px;
`;

export const CheckboxLineWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  margin-bottom: 12px;
  flex-wrap: wrap;
`;

export const FormTitle = styled(Typography)`
  font-weight: 600 !important;
  font-size: 20px !important;
  color: ${COLORS['primary/900']};
  margin-bottom: 20px !important;
`;

export const ButtonText = styled(Typography)`
  text-transform: none;
  font-weight: 600;
`;
